<template>
  <div
    class="multi-avatar"
    :class="[`extra-${thumbnails.length}`]"
    :style="cssProps"
  >
    <lazy-image
      v-for="thumbnail in thumbnails"
      :key="thumbnail.id"
      :src="thumbnail.thumbnailUrl"
      :fallback="require('@/assets/placeholder96x96.png')"
      wrapperClass="multi-avatar__avatar"
    />
  </div>
</template>

<script>
import LazyImage from '../lazy/LazyImage.vue'
export default {
  components: { LazyImage },
  name: 'MultiThumbnail',
  props: {
    media: {
      type: Array,
      default: () => [],
    },
    size: {
      type: Number,
      default: 48,
    },
  },
  data() {
    return {}
  },
  computed: {
    thumbnails() {
      return this.media.slice(0, 4)
    },
    cssProps() {
      return {
        '--tile-size': this.size + 'px',
        '--small-tile-size': this.size / 2 + 'px',
        '--border-radius': this.size / 6 + 'px',
      }
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

.multi-avatar {
  display: flex;
  z-index: 2;
  border-radius: var(--border-radius);
  overflow: hidden;

  @include imageAvatar(
    $class-name: 'multi-avatar',
    $height: var(--small-tile-size),
    $width: var(--small-tile-size),
    $radius: 0
  );

  &.extra-1 {
    .multi-avatar__avatar {
      width: var(--tile-size);
      height: var(--tile-size);
    }
  }

  &.extra-2 {
    .multi-avatar__avatar {
      width: var(--small-tile-size);
      height: var(--tile-size);
    }
  }
  &.extra-3 {
    width: var(--tile-size);
    position: relative;
    .multi-avatar__avatar {
      width: var(--small-tile-size);
      height: var(--small-tile-size);
    }
    .multi-avatar__avatar:first-child {
      width: var(--small-tile-size);
      height: var(--tile-size);
    }
    .multi-avatar__avatar:last-child {
      position: absolute;
      right: 0;
      bottom: 0;
    }
  }

  &.extra-4 {
    width: var(--tile-size);
    flex-wrap: wrap;
    .multi-avatar-extra__avatar {
      width: var(--small-tile-size);
      height: var(--small-tile-size);
    }
  }
}
</style>
